import fromFormat from "./fromFormat";
import { getDefaultDateFormat, getDefaultDateFormatPattern, isIntlDefaultDateFormat } from "./defaultDateFormat";

export default function fromDefaultDateFormat(x: string) {
  if (!x || typeof x !== "string") return undefined as any;

  if (/^\d{4}-\d{2}-\d{2}$/.test(x)) {
    const parsedFromISODateOnly = fromFormat(x, "yyyy-MM-dd");
    if (parsedFromISODateOnly && !isNaN(parsedFromISODateOnly.getTime())) return parsedFromISODateOnly;
  }

  const defaultDateFormat = getDefaultDateFormat();
  if (isIntlDefaultDateFormat(defaultDateFormat)) {
    const parsedFromDateCtor = new Date(x);
    if (!isNaN(parsedFromDateCtor.getTime())) return parsedFromDateCtor;

    const fallbackPatterns = ["dd/MM/yyyy", "MM/dd/yyyy"];
    for (const pattern of fallbackPatterns) {
      const parsed = fromFormat(x, pattern);
      if (parsed && !isNaN(parsed.getTime())) return parsed;
    }
    return undefined as any;
  }

  return fromFormat(x, getDefaultDateFormatPattern());
}
